/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ChainlinkPriceFeedV3,
  ChainlinkPriceFeedV3Interface,
} from "../ChainlinkPriceFeedV3";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract AggregatorV3Interface",
        name: "aggregator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "timeout",
        type: "uint256",
      },
      {
        internalType: "uint80",
        name: "twapInterval",
        type: "uint80",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum IChainlinkPriceFeedV3Event.FreezedReason",
        name: "freezedReason",
        type: "uint8",
      },
    ],
    name: "ChainlinkPriceUpdated",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "interval",
        type: "uint256",
      },
    ],
    name: "cacheTwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "currentObservationIndex",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAggregator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getFreezedReason",
    outputs: [
      {
        internalType: "enum IChainlinkPriceFeedV3Event.FreezedReason",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLastValidPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLastValidTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLatestOrCachedPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "interval",
        type: "uint256",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTimeout",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isTimedOut",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "observations",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "priceCumulative",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "update",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ChainlinkPriceFeedV3__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    aggregator: string,
    timeout: BigNumberish,
    twapInterval: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ChainlinkPriceFeedV3> {
    return super.deploy(
      aggregator,
      timeout,
      twapInterval,
      overrides || {}
    ) as Promise<ChainlinkPriceFeedV3>;
  }
  getDeployTransaction(
    aggregator: string,
    timeout: BigNumberish,
    twapInterval: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      aggregator,
      timeout,
      twapInterval,
      overrides || {}
    );
  }
  attach(address: string): ChainlinkPriceFeedV3 {
    return super.attach(address) as ChainlinkPriceFeedV3;
  }
  connect(signer: Signer): ChainlinkPriceFeedV3__factory {
    return super.connect(signer) as ChainlinkPriceFeedV3__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ChainlinkPriceFeedV3Interface {
    return new utils.Interface(_abi) as ChainlinkPriceFeedV3Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ChainlinkPriceFeedV3 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ChainlinkPriceFeedV3;
  }
}
